import { useAuth } from "./useAuth"

// ----------------------------------------------------------------------------

// Permission matrix matching the backend ROLES/BACKOFFICE_ROLES/WRITE_ROLES
//
// | Action                         | admin | operator | viewer |
// |--------------------------------|-------|----------|--------|
// | View clients, points, reports  |  ✅   |    ✅    |   ✅   |
// | Adjust/recalculate points      |  ✅   |    ✅    |   ❌   |
// | Cancel redemptions             |  ✅   |    ✅    |   ❌   |
// | Reset user password            |  ✅   |    ✅    |   ❌   |
// | Edit contract dates            |  ✅   |    ✅    |   ❌   |
// | Manage users & roles           |  ✅   |    ❌    |   ❌   |
// | Edit rules & settings          |  ✅   |    ❌    |   ❌   |
// | View settings page             |  ✅   |    ❌    |   ❌   |

export function usePermissions() {
  const { user } = useAuth()
  const role = user?.role || ""

  const isAdmin = role === "admin"
  const isOperator = role === "operator"
  const isViewer = role === "viewer"

  return {
    role,
    isAdmin,
    isOperator,
    isViewer,

    canManageUsers: isAdmin,
    canWritePoints: isAdmin || isOperator,
    canEditRules: isAdmin,
    canEditSettings: isAdmin,
    canViewSettings: isAdmin,
    canResetPassword: isAdmin || isOperator,
    canEditContracts: isAdmin || isOperator,
    canCancelRedemptions: isAdmin || isOperator,
  }
}
